// import css from "./product.module.css";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../svg/sendMess.svg";
// import { v4 as uuidv4 } from "uuid";
// import { auth, db } from "../../firebase";
// import {
//   doc,
//   setDoc,
//   addDoc,
//   collection,
//   serverTimestamp,
//   updateDoc,
//   getDoc,
// } from "firebase/firestore";
// import { useState } from "react";
// import { useEffect } from "react";

// export default function ResponsTextArea({
//   oneProd,
//   setReloadP,
//   reloadP,
//   user,
//   setRerenderAfter,
//   rerenderAfter,
// }) {
//   const [areT, setAreaT] = useState("");

//   const changeTextArea = (e) => {
//     e.preventDefault();
//     setAreaT(e.target.value);
//   };
//   const sendVidguk = async () => {
//     if (areT.length < 350) {
//       alert("Мінімальна кількість символів для відгуку - 350");
//       return;
//     }

//     const uid = uuidv4();
//     const frankDocRef = doc(db, "reviews", uid);
//     await setDoc(frankDocRef, {
//       uid: uid,
//       productId: oneProd.uid,
//       productName: oneProd.bookName || "",
//       vidguk: areT,
//       nameAutor: user.displayName || user.email || "Користувач",
//       autorPic: user.photoURL || "",
//       rating: 4,
//       userUid: user.uid,
//       visible: true,
//       createdAt: serverTimestamp(),
//       updatedAt: serverTimestamp(),
//     });
//     setAreaT("");
//     setReloadP(!reloadP);
//     try {
//       const userDocRef = doc(db, "users", user.uid);

//       // Отримуємо попереднє значення elefant
//       const userDoc = await getDoc(userDocRef);
//       const previousElefant = userDoc.data().elefant;
//       const elefantNumber = parseInt(previousElefant, 10);

//       const newElefant1 = (oneProd.price * 5) / 100;

//       const updatedElefant = elefantNumber + newElefant1;

//       await updateDoc(userDocRef, { elefant: updatedElefant.toString() });

//       alert(
//         `Ваш відгук успішно відправлений та нараховано ${newElefant1} слонів`,
//       );
//       setRerenderAfter(!rerenderAfter);
//     } catch (error) {
//       console.error("Error updating elefant:", error);
//     }
//   };

//   return (
//     <div className={css.respTextAreaWrap}>
//       <div className={css.respTextAreaWrapSmall}>
//         <textarea
//           value={areT}
//           onChange={changeTextArea}
//           placeholder="Залишити відгук..."
//           className={css.textAreaStyle}
//         ></textarea>

//         <div className={css.sendMessage} onClick={sendVidguk}>
//           <HandySvg src={iconSrc} width="40.25" height="43.2" />
//         </div>
//       </div>
//     </div>
//   );
// }
import css from "./product.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../svg/sendMess.svg";
import starLike from "../../svg/starLike.svg";
import starDontLike from "../../svg/starDontLike.svg";
import { v4 as uuidv4 } from "uuid";
import { db } from "../../firebase";
import { doc, setDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { useState } from "react";

export default function ResponsTextArea({
  oneProd,
  setReloadP,
  user,
  setRerenderAfter,
}) {
  const [areT, setAreaT] = useState("");

  // Обрана користувачем оцінка
  const [rating, setRating] = useState(0);

  // Зірка, на яку зараз наведений курсор
  const [hoverRating, setHoverRating] = useState(0);

  // Захист від повторного натискання під час відправлення
  const [isSending, setIsSending] = useState(false);

  const changeTextArea = (e) => {
    setAreaT(e.target.value);
  };

  const sendVidguk = async () => {
    const trimmedReview = areT.trim();

    // Спочатку перевіряємо оцінку
    if (rating === 0) {
      alert("Поставте оцінку в зірочках");
      return;
    }

    // Потім перевіряємо довжину відгуку
    if (trimmedReview.length < 350) {
      alert("Мінімальна кількість символів для відгуку — 350");
      return;
    }

    if (!user?.uid) {
      alert("Для додавання відгуку потрібно авторизуватися");
      return;
    }

    if (!oneProd?.uid) {
      alert("Не вдалося визначити товар");
      return;
    }

    if (isSending) {
      return;
    }

    setIsSending(true);

    try {
      const uid = uuidv4();
      const reviewDocRef = doc(db, "reviews", uid);

      // Зберігаємо відгук з обраною оцінкою
      await setDoc(reviewDocRef, {
        uid,
        productId: oneProd.uid,
        productName: oneProd.bookName || "",
        vidguk: trimmedReview,
        nameAutor: user.displayName || user.email || "Користувач",
        autorPic: user.photoURL || "",
        rating,
        userUid: user.uid,
        visible: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      const newElefant = (Number(oneProd.price) * 5) / 100;
      let rewardWasAdded = false;

      try {
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);

        const previousElefant = Number(userDoc.data()?.elefant) || 0;
        const updatedElefant = previousElefant + newElefant;

        // setDoc з merge працює навіть тоді,
        // коли поле elefant раніше було відсутнє
        await setDoc(
          userDocRef,
          {
            elefant: updatedElefant.toString(),
          },
          {
            merge: true,
          },
        );

        rewardWasAdded = true;
      } catch (rewardError) {
        console.error("Помилка нарахування слонів:", rewardError);
      }

      // Очищаємо форму після успішного збереження
      setAreaT("");
      setRating(0);
      setHoverRating(0);

      setReloadP((previousValue) => !previousValue);
      setRerenderAfter((previousValue) => !previousValue);

      if (rewardWasAdded) {
        alert(
          `Ваш відгук успішно відправлений та нараховано ${newElefant} слонів`,
        );
      } else {
        alert(
          "Ваш відгук успішно відправлений, але бонусні слони не були нараховані",
        );
      }
    } catch (error) {
      console.error("Помилка додавання відгуку:", error);

      alert("Не вдалося додати відгук. Спробуйте ще раз");
    } finally {
      setIsSending(false);
    }
  };

  // Під час наведення показуємо попередній вибір.
  // Коли курсор не наведений — показуємо фактичну оцінку.
  const displayedRating = hoverRating || rating;

  return (
    <div className={css.respTextAreaWrap}>
      <div className={css.respTextAreaWrapSmall}>
        <div className={css.reviewRatingBlock}>
          <p className={css.reviewRatingTitle}>Ваша оцінка:</p>

          <div
            className={css.reviewRatingStars}
            onMouseLeave={() => setHoverRating(0)}
          >
            {[1, 2, 3, 4, 5].map((starNumber) => {
              const isActive = starNumber <= displayedRating;

              return (
                <button
                  key={starNumber}
                  type="button"
                  className={css.reviewRatingButton}
                  onClick={() => setRating(starNumber)}
                  onMouseEnter={() => setHoverRating(starNumber)}
                  onFocus={() => setHoverRating(starNumber)}
                  onBlur={() => setHoverRating(0)}
                  aria-label={`Поставити оцінку ${starNumber} з 5`}
                >
                  <HandySvg
                    src={isActive ? starLike : starDontLike}
                    className={css.reviewRatingStar}
                    width="32"
                    height="31"
                  />
                </button>
              );
            })}

            <span className={css.reviewRatingValue}>
              {rating > 0 ? `${rating} з 5` : "Оберіть оцінку"}
            </span>
          </div>
        </div>

        <div className={css.reviewInputRow}>
          <textarea
            value={areT}
            onChange={changeTextArea}
            placeholder="Залишити відгук..."
            className={css.textAreaStyle}
          />

          <button
            type="button"
            className={css.sendMessage}
            onClick={sendVidguk}
            disabled={isSending}
            aria-label="Відправити відгук"
          >
            <HandySvg src={iconSrc} width="40.25" height="43.2" />
          </button>
        </div>
      </div>
    </div>
  );
}
